import { CommonModule } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgSelectModule } from '@ng-select/ng-select';
import { RagDatasupplyModule } from '@reflact/rag-datasupply';
import { NgxEditorModule } from 'ngx-editor';
import { ToastrModule } from 'ngx-toastr';
import { providePrimeNG } from 'primeng/config';
import { AccordionModule } from 'primeng/accordion';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { DialogModule } from 'primeng/dialog';
import { DrawerModule } from 'primeng/drawer';
import { InputTextModule } from 'primeng/inputtext';
import { MenuModule } from 'primeng/menu';
import { PickListModule } from 'primeng/picklist';
import { SelectModule } from 'primeng/select';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { TabsModule } from 'primeng/tabs';
import { TooltipModule } from 'primeng/tooltip';
import { ReflactTheme } from '@reflact/primeng-theme';
import { PortalUserMenuComponent } from '@reflact/portal-ecosystem';
import { ThemeService } from './shared/services/theme.service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BodyLayoutComponent } from './shared/components/body-layout/body-layout.component';
import { TestUserBadgeComponent } from './shared/components/test-user-badge/test-user-badge.component';
import { OverlayAsideComponent } from './shared/components/overlay-aside/overlay-aside.component';
import { FormComponent } from './shared/components/form/form.component';
import { TileIconPickerComponent } from './shared/components/tile-icon-picker/tile-icon-picker.component';
import { TileIconComponent } from './shared/components/tile-icon/tile-icon.component';
import { TilePreviewComponent } from './shared/components/tile-preview/tile-preview.component';
import { TileImageEditorComponent } from './shared/components/tile-image-editor/tile-image-editor.component';
import { TileImageBackfillComponent } from './shared/components/tile-image-backfill/tile-image-backfill.component';
import { WebTileEditorComponent } from './shared/components/web-tile-editor/web-tile-editor.component';
import { HomeWidgetDialogComponent } from './shared/components/home-widgets/home-widget-dialog.component';
import { NoteTileComponent } from './shared/components/home-widgets/note-tile.component';
import { ClockTileComponent } from './shared/components/home-widgets/clock-tile.component';
import { WeatherTileComponent } from './shared/components/home-widgets/weather-tile.component';
import { ContenttypeIconComponent } from './shared/components/contenttype-icon/contenttype-icon.component';
import { LayoutComponent } from './shared/components/layout/layout.component';
import { ServiceMessageComponent } from './shared/components/service-message/service-message.component';
import { SimplePieComponent } from './shared/components/simple-pie/simple-pie.component';
import { UserManagementComponent } from './shared/components/user-management/user-management.component';
import { VkcDisplayComponent } from './shared/components/vkc-display/vkc-display.component';
import { NgVarDirective } from './shared/directives/ng-var.directive';
import { AuthInterceptor } from './shared/interceptors/auth.interceptor';
import { FileSizePipe } from './shared/pipes/file-size.pipe';
import { NobreakPipe } from './shared/pipes/nobreak.pipe';
import { ShortyPipe } from './shared/pipes/shorty.pipe';
import { DashboardAdministrationComponent } from './views/dashboard-administration/dashboard-administration.component';
import { ActivityInsightsComponent } from './views/dashboard-administration/activity-insights.component';
import { GlobalUserAdministrationComponent } from './views/global-user-administration/global-user-administration.component';
import { LoginComponent } from './views/login/login.component';
import { LogtoCallbackComponent } from './views/logto-callback/logto-callback.component';
import { MandantAdministrationComponent } from './views/mandant-administration/mandant-administration.component';
import { SettingsAdministrationComponent } from './views/settings-administration/settings-administration.component';
import { TileAdministrationComponent } from './views/tile-administration/tile-administration.component';
import { ToolsAndTrainingsComponent } from './views/tools-and-trainings/tools-and-trainings.component';
import { UserAdministrationComponent } from './views/user-administration/user-administration.component';
import { WelcomeComponent } from './views/welcome/welcome.component';
@NgModule({
  declarations: [
    AppComponent,
    WelcomeComponent,
    ToolsAndTrainingsComponent,
    UserAdministrationComponent,
    GlobalUserAdministrationComponent,
    UserManagementComponent,
    LoginComponent,
    LogtoCallbackComponent,
    LayoutComponent,
    MandantAdministrationComponent,
    TileAdministrationComponent,
    DashboardAdministrationComponent,
    SettingsAdministrationComponent,
    VkcDisplayComponent,
    SimplePieComponent,
    NgVarDirective,
    ServiceMessageComponent,
    NobreakPipe,
    FileSizePipe,
    ShortyPipe,
    ContenttypeIconComponent
  ],
  bootstrap: [AppComponent],
  exports: [
    NgVarDirective
  ], imports: [BrowserModule,
    AppRoutingModule,
    BodyLayoutComponent,
    ActivityInsightsComponent,
    TestUserBadgeComponent,
    PortalUserMenuComponent,
    OverlayAsideComponent,
    FormComponent,
    TilePreviewComponent,
    TileIconComponent,
    TileImageEditorComponent,
    TileImageBackfillComponent,
    WebTileEditorComponent,
    HomeWidgetDialogComponent,
    NoteTileComponent,
    ClockTileComponent,
    WeatherTileComponent,
    TileIconPickerComponent,
    RagDatasupplyModule,
    FormsModule,
    CommonModule,
    NgSelectModule,
    ToastrModule.forRoot({ positionClass: 'toast-top-left', preventDuplicates: true }),
    BrowserAnimationsModule,
    NgxEditorModule,
    MenuModule,
    DragDropModule,
    DialogModule,
    DrawerModule,
    InputTextModule,
    ButtonModule,
    CardModule,
    TableModule,
    TagModule,
    AvatarModule,
    PickListModule,
    TabsModule,
    AccordionModule,
    TooltipModule,
    SelectModule], providers: [
      {
        provide: HTTP_INTERCEPTORS,
        useClass: AuthInterceptor,
        multi: true
      },
      provideHttpClient(withInterceptorsFromDi()),
      provideAppInitializer(() => { inject(ThemeService); }),
      providePrimeNG({
        license: "eyJpZCI6IjVmM2VkMTFmLTdlYjUtNGU2Zi04NGVkLTllZTU2ODY4OTE4OSIsInByb2R1Y3QiOiJwcmltZXVpIiwidGllciI6ImNvbW1lcmNpYWwiLCJ0eXBlIjoiZGV2IiwiaWF0IjoxNzkwMDYzMDA5LCJleHAiOjE4MjE1OTg0ODR9.Sjd73vdaF3nvGMu_Y6xAyQeNzN_6BfEZYnQ9KVzuF83Y7HCZY7yKAuu4aMLTXozfFBtcBTVoiL_OE-SDovfcCw",
        theme: ReflactTheme
      })
    ]
})
export class AppModule { }
